import styled from "@emotion/styled";
import { colors } from "goi_common";

const Divider = styled.div`
  height: 1px;
  background-color: ${colors.gray800};
`;

export default Divider;
